import React from "react";
import BigNumber from '../../../../frontend/components/components/utils/numbers/BigNumber';
import Percent from '../../../../frontend/components/components/utils/numbers/Percent';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { get, isString } from "lodash-es";

const SimplifiedAudience = ({
  data,
  averageFollowers = false,
  authenticFollowers = false,
  monthlyActiveFollowers = false
}) => {
  if (!data) return;

  const { t } = useTranslation();

  const getMetricPercentage = (metric) => {
    const authenticFollowerPercentage = get(data, `stats.${metric}`);

    return isString(authenticFollowerPercentage) ?
      authenticFollowerPercentage :
      <Percent number={authenticFollowerPercentage || 0.0} />
  };

  return (
    <React.Fragment>
      <h4 className='mb-5'>
        {t('common.pages.analytics.audience')}
      </h4>
      <Row className='mb-6'>
        {
          averageFollowers &&
          (get(data, 'stats.avg_followers') || get(data, 'stats.audience_avg_followers')) &&
          <Col xs={12} sm={4}>
            <h3><BigNumber number={get(data, 'stats.avg_followers') || get(data, 'stats.audience_avg_followers') || 0} /></h3>
            <div className="mb-3">
              {t('common.pages.analytics.average_size_followers')}
            </div>
          </Col>
        }
        {
          authenticFollowers &&
          get(data, 'stats.authentic_followers') &&
          <Col xs={12} sm={4}>
            <h3>{getMetricPercentage('authentic_followers')}</h3>
            <div className="mb-3">
              {t('common.pages.analytics.authentic_followers')}
            </div>
          </Col>
        }
        {
          monthlyActiveFollowers &&
          get(data, 'stats.monthly_active_followers') &&
          <Col xs={12} sm={4}>
            <h3>{getMetricPercentage('monthly_active_followers')}</h3>
            <div className="mb-3">
              {t('common.pages.analytics.monthly_active_followers')}
            </div>
          </Col>
        }
      </Row>
    </React.Fragment >
  );
};

export default SimplifiedAudience;
